/**
 * ReportUserModal Component
 * Wrapper for ReportModal with user-specific props
 * @deprecated Use ReportModal instead
 */

import { ReportModal, type ReportModalProps } from "./ReportModal"

interface ReportUserModalProps extends Omit<ReportModalProps, "target" | "targetData"> {
  user: {
    id: string
    name: string
    username: string
    profilePictureUrl?: string | null
  }
}

export function ReportUserModal({ open, onOpenChange, user }: ReportUserModalProps) {
  return (
    <ReportModal
      open={open}
      onOpenChange={onOpenChange}
      target="USER"
      targetData={{
        id: user.id,
        name: user.name,
        handle: user.username,
        imageUrl: user.profilePictureUrl,
      }}
    />
  )
}

export type { ReportModalProps } from "./ReportModal"
export { ReportModal }
